import React from 'react';
import PropTypes from 'prop-types';

export default function SessionCountItem({
  countSessions, isActive, onClick, last, className, buttonStyle,
}) {
  return (
    <span
      role="button"
      onClick={() => onClick(countSessions)}
      onKeyDown={() => onClick(countSessions)}
      tabIndex={0}
      className={
        `radio ${isActive ? 'selected' : ''} form-check form-check-inline form-check-buttons `
        + `m-0 ${last ? '' : 'me-3'} ${className}`
      }
    >
      <div
        className="form-check-label collection_radio_buttons"
        style={buttonStyle}
      >
        {countSessions}
      </div>
    </span>
  );
}

SessionCountItem.propTypes = {
  countSessions: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  last: PropTypes.bool,
  className: PropTypes.string,
  buttonStyle: PropTypes.object,
};

SessionCountItem.defaultProps = {
  isActive: false,
  onClick: () => {},
  last: false,
  className: '',
  buttonStyle: {},
};
